/* eslint-disable */
import React, {PropTypes} from 'react';
import TimeLineItem from './TimeLineItem'
import ConfigD from './util/ConfigD';
import 'jquery-validation';
import $ from 'jquery';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import './css/VerticalTimeline.css';
import './css/VerticalTimelineElement.css';
import './css/visualizarProtocolo.css'


//https://stephane-monnot.github.io/react-vertical-timeline/#/demo

class ProtocoloTimeLineCliente extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        this.state = {
        };
        this.abrirPanel = this.abrirPanel.bind(this);

    }

    abrirPanel(mensagem, historico, texto){
        this.props.abrirPanel(mensagem, historico, texto);
    }

    componentDidMount() {        
        if ($.isEmptyObject(this.props.mensagem)) {
            this.context.router.push(ConfigD.getServerBase() + '/consultarProtocolo');

        }
    }
    
    componentWillReceiveProps(nextProps) {

        
        //if(!$.isEmptyObject(nextProps.clienteLogado)){
           
            //enviar para página de oses desse cliente com a situação delas. 
            //this.context.router.push('/servico');
        //}
      
    }
    
    render() {
        console.log('this.props.mensagem.mHistoricos ', this.props.mensagem.mHistoricos)
    return (
        
        <div>
            <form method="post" id='login-form' >
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="contact-box widget">
                        <h3 className='tituloBoxWhite'>Protocolo: {this.props.mensagem.mAtendimento.mProtocolo}</h3>
                        <i className="fa fa-bullhorn"></i>
                        <p>Veja abaixo o tratamento da sua manifestação:</p>
                    </div>
                
                    <VerticalTimeline>
                        {this.props.mensagem.mHistoricos.map(historico =>
                        
                            <TimeLineItem 
                                mensagem={this.props.mensagem}
                                historico={historico} 
                                key={historico.mIdHistoricoMensagem} 
                                estiloCliente={{ background: 'rgb(141, 209, 225)', color: '#8dd1e1' }}
                                estiloOuvidoria={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                                position={(historico.mSituacao.mIdSituacao === 1 && historico.mMovimentacaoMensagem === 0)|| historico.mSituacao.mIdSituacao === 10 ? 'left' : 'right'} 
                                texto={(historico.mSituacao.mIdSituacao === 1 && historico.mMovimentacaoMensagem === 0)  ? this.props.mensagem.mTextoCidadao.replace(/(\n)+/g, '<br />') : historico.mTextoMensagem ? historico.mTextoMensagem.replace(/(\n)+/g, '<br />') : historico.mTextoMensagem} 
                                classe={(historico.mSituacao.mIdSituacao === 1 && historico.mMovimentacaoMensagem === 0) || historico.mSituacao.mIdSituacao === 10 ? 'vertical-timeline-element--education' : 'vertical-timeline-element--work'}
                                abrirPanel={this.abrirPanel}
                            />
                        )}
                    </VerticalTimeline>
                </div>
            </form>
        </div>
    );
  }
}

ProtocoloTimeLineCliente.protoType = {
    actionCliente: PropTypes.object.isRequired
}
ProtocoloTimeLineCliente.contextTypes = {
  router: React.PropTypes.object
};


export default ProtocoloTimeLineCliente;



/** WEBPACK FOOTER **
 ** ./src/components/ProtocoloTimeLineCliente.js
 **/